
export const AMC_UPLOAD_DOCUMENTS = "allSureMotorClaim/uploadDocuments/";
export const AMC_UPLOAD_DOCUMENTS_SET_VALUE = AMC_UPLOAD_DOCUMENTS+"setValue/";
export const AMC_UPLOAD_DOCUMENTS_SET_VALID = AMC_UPLOAD_DOCUMENTS +"setValid/";
export const setAmcDocumentValue =(value)=>({type: AMC_UPLOAD_DOCUMENTS_SET_VALUE, value})
export const setAmcDocumentValid =(error,fileType)=>({type: AMC_UPLOAD_DOCUMENTS_SET_VALID, error, fileType})


export const AMC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT = AMC_UPLOAD_DOCUMENTS +"addAdditionalDocument";
export const addAdditionalDocuments =()=>({type: AMC_UPLOAD_DOCUMENTS_ADDITIONAL_DOCUMENT})

export const AMC_SYNC_DOCUMENTS = AMC_UPLOAD_DOCUMENTS +"syncRequiredDocuments";
export const syncAllRequiredDocuments =(value)=>({type: AMC_SYNC_DOCUMENTS, value})


export const AMC_UPLOAD_DOCUMENTS_RESET = AMC_UPLOAD_DOCUMENTS +"reset";
export const resetAmcDocuments =()=>({type: AMC_UPLOAD_DOCUMENTS_RESET})

const SIZE_2_MB = 2097152;
const SIZE_1_kb = 1024;


export const AMC_UPLOAD_DOCUMENTS_CONFIG = {

  MIN_INPUT_SIZE: SIZE_1_kb,
  MIN_INPUT_SIZE_NAME: '1 kb',
  MAX_INPUT_SIZE: SIZE_2_MB,
  MAX_INPUT_SIZE_NAME: '2 mb',
  VALID_UPLOAD_TYPES: [
      { FORMAT: 'image/jpeg', FORMAT_NAME: 'JPG' },
      {FORMAT: 'image/png', FORMAT_NAME: 'PNG'},
      { FORMAT: 'application/pdf', FORMAT_NAME: 'PDF' },
  ],
};

export const AMC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE = AMC_UPLOAD_DOCUMENTS+"/setPresignedValue";
export const updateAmcPresignedUrl =(value)=>({type: AMC_UPLOAD_DOCUMENTS_SET_PRESIGNED_VALUE, value})